module.exports = __webpack_public_path__ + "img/bottom_allow_active.adf9f5e7.svg";